import SingleSelectHookForm from "Components/CommonComponents/SingleSelectHookForm";
import { LoginFormFields } from "Pages/UserManagement/UserManagementForm";
import { useRef } from "react";
import { useForm } from "react-hook-form";
import { Card } from "reactstrap";
import styled from "styled-components";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import RightArrowWhiteIcon from "Assets/Icons/RightArrowWhiteIcon";
const ListingDiv = styled<any>("div")`
  display: flex;
  justify-content: space-between;
  padding: 16px 12px;
  cursor: pointer;
  background: ${({ isSelected }: any) => (isSelected ? "#008DC4" : "#ffffff")};
  color: ${({ isSelected }: any) => (isSelected ? "#fff" : "#333")};
`;
const ScheduledDiv1Card = styled<any>(Card)`
  height: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "calc(100% - 162px)" : "100%"};
  overflow: auto;
  background: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "#FCFCFC" : ""};
`;
const StyledSpan = styled<any>("span")`
  font-size: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "12px" : ""};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  margin-top: 2px;
`;
const DocumentTypeListingCard = ({
  docTypes,
  selectedDocType,
  setSelectedDocType,
}: any) => {
  const {
    register,
    control,
    formState: { errors },
  } = useForm<LoginFormFields>();
  const { screen } = useWindowSize();
  const selectedListingRef: any = useRef(null);

  console.log("checking selected doc types", selectedDocType);
  return (
    <>
      {["xs", "sm", "md"].includes(screen) ? (
        <SingleSelectHookForm
          disabled={false}
          error={errors}
          controlName={control}
          placeholder="Document Type"
          width="100%"
          isInPerformance={false}
          options={docTypes}
          menuPlacement="bottom"
          isClearable={false}
          isSearchable={false}
          isSearchableDrop={true}
          isDropdownSelect={true}
          top={"0px"}
          menuShouldScrollIntoView={true}
          closeMenuOnSelect={true}
          hideSelectedOptions={false}
          name={"date"}
          register={register}
          onChange={(selected: any) => {
            setSelectedDocType(selected);
          }}
          defaultValue={selectedDocType ? selectedDocType : null}
        />
      ) : (
        <ScheduledDiv1Card screen={screen}>
          <div className="documentTitle">Document Type</div>
          <div className="listingDivPlanner">
            {docTypes.map((ele: any, index: number) => {
              return (
                <ListingDiv
                  ref={
                    selectedDocType?.value == ele.value
                      ? selectedListingRef
                      : null
                  }
                  key={index}
                  isSelected={selectedDocType?.value == ele.value}
                  onClick={() => {
                    setSelectedDocType(ele);
                  }}
                >
                  <div className="d-flex align-items-center">
                    <StyledSpan screen={screen}>{ele.label}</StyledSpan>
                  </div>
                  <div className="d-flex align-items-center">
                    {ele.value != selectedDocType?.value ? (
                      <></>
                    ) : (
                      <RightArrowWhiteIcon></RightArrowWhiteIcon>
                    )}
                  </div>
                </ListingDiv>
              );
            })}
          </div>
        </ScheduledDiv1Card>
      )}
    </>
  );
};
export default DocumentTypeListingCard;
